import { AppointmentRecord, AppointmentRecordPatientCase } from "~/api/API";

export const sortAppointmentPatientCasesByCreationDate = (
  appointmentPatientCases: (AppointmentRecordPatientCase | null)[],
) => {
  return appointmentPatientCases
    .filter((item): item is AppointmentRecordPatientCase => item !== null)
    .sort((a, b) => {
      return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    });
};

export const sortPatientCases = (appointment: AppointmentRecord) => {
  const cases =
    appointment.patientCases?.items.filter(
      (item): item is AppointmentRecordPatientCase => item !== null,
    ) || [];

  if (appointment.primaryPatientCaseID) {
    const [primaryCases, otherCases] = cases.reduce(
      ([primary, others], currentCase) => {
        if (currentCase.patientCase.id === appointment.primaryPatientCaseID) {
          return [[...primary, currentCase], others];
        }
        return [primary, [...others, currentCase]];
      },
      [[], []] as [typeof cases, typeof cases],
    );

    return [
      ...primaryCases,
      ...sortAppointmentPatientCasesByCreationDate(otherCases),
    ];
  }

  // If no primary case ID, sort all by creation date
  return sortAppointmentPatientCasesByCreationDate(cases);
};
